import { render } from "./FooterCopyright.vue?vue&type=template&id=76cb51ee&scoped=true"
import script from "./FooterCopyright.vue?vue&type=script&lang=js"
export * from "./FooterCopyright.vue?vue&type=script&lang=js"

import "./FooterCopyright.vue?vue&type=style&index=0&id=76cb51ee&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-76cb51ee"

export default script